import React from 'react';
import 'chart.js/auto';
import { Bar } from 'react-chartjs-2';
import { useTranslation } from 'react-i18next';
import { Box, Card, CardContent, CardHeader, Divider, Typography, useTheme } from '@mui/material';

const Invoiced6Months = ({ stats, isLoading, isError }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const months = stats?.months || [];
  const missingRates = months.some(({ current, previous }) => current === null || previous === null);
  const data = {
    labels: months.map(({ label }) => label),
    datasets: [
      { label: t('dashboard.previous_year'), data: months.map(({ previous }) => previous), backgroundColor: '#FB8C00', borderRadius: 4, maxBarThickness: 12 },
      { label: t('dashboard.current_year'), data: months.map(({ current }) => current), backgroundColor: '#3F51B5', borderRadius: 4, maxBarThickness: 12 },
    ],
  };
  const options = {
    animation: false, responsive: true, maintainAspectRatio: false,
    plugins: { legend: { position: 'top' } },
    scales: {
      x: { ticks: { color: theme.palette.text.secondary }, grid: { display: false } },
      y: { beginAtZero: true, ticks: { color: theme.palette.text.secondary }, grid: { color: theme.palette.divider } },
    },
  };
  return (
    <Card>
      <CardHeader title={t('dashboard.latest_sales')} subheader={t('dashboard.in_mdl_at_nbm_exchange_rate')}
        action={<Typography variant="body2">{t('dashboard.last_6_months')}</Typography>}
        sx={{ backgroundColor: '#f1f1f1', minHeight: 85 }} />
      <Divider />
      <CardContent>
        <Box sx={{ height: 375, position: 'relative' }}>
          {isLoading && !stats ? <Typography>{t('dashboard.loading')}</Typography> :
            isError && !stats ? <Typography>{t('dashboard.load_error')}</Typography> :
            missingRates ? <Typography>{t('dashboard.missing_exchange_rates')}</Typography> :
            stats ? <Bar data={data} options={options} /> : null}
        </Box>
      </CardContent>
    </Card>
  );
};

export default Invoiced6Months;
